import React, { useEffect } from 'react';
import { PathUtils } from '@adobe/aem-spa-page-model-manager';
import SessionStorage from '../../utils/SessionStorage';
import { usePushdownContext } from '../../providers/Pushdown/PushdownProvider';

export const UnsupportedBrowsersWrapper = (props:any) => {

    interface IUserBrowser {
        os?: string;
        browserName?: string,
        version?: string
    }

    interface IWarnBrowser {
        osName: string;
        browserName: string;
        browserVersionMinimum: string;
        browserVersionSupported: string;
    }

    interface IRedirectBrowser {
        value: string;
    }
    
    const { showPushdown } = usePushdownContext();
    const isObjEmpty = (obj: IUserBrowser) => {
        return (typeof obj !== undefined && obj !== null && Object.keys(obj).length !== 0);
    };

    const parseVersions = (versions: any) => {
        return versions.map((version: string) => version.split('.')[0])
            .map((str: string) => {
                return parseInt(str);
            });
    };

    const isUserVersionWithinRange = (minVersion: any, userVersion:any, actualSupported: any) => {
        const parsedVersions = parseVersions([minVersion, userVersion, actualSupported]);

        if ((parsedVersions[0] <= parsedVersions[1]) && (parsedVersions[1] < parsedVersions[2])) {
            return true;
        } 
        return false; 
    };

    function handleUnsupportedBrowsers() {
        const parseUserBrowser = (browser: string) => {
            const parsedBrowser = { os: '', browserName: '', version: '' };

            if (!browser) {
                return parsedBrowser;
            }

            const parensRegex = /\(([^()]+)\)/;
            const browserRegex = /(Chrome|Firefox|Safari)\/([^\s]+)/g;
            const osTypes = ['Windows', 'Android', 'Mac', 'iPhone'];
            const versionRegex = /(\d+\.)?(\d+\.)?(\*|\d+)/g;

            const osResult = browser.match(parensRegex);
            if (osResult !== null) {
                const parsedOS = osResult[0].replace(/_/g, '.').replace(/ NT| OS|/gi, '');
                const versionResult = parsedOS.match(versionRegex);
   
                osTypes.forEach((os) => {
                    if (parsedOS.includes(os) && versionResult) {
                        parsedBrowser.os = os + ' ' + versionResult[0].split('.')[0];
                    }
                });
    
            }

            const regexResult = browser.match(browserRegex);
            if (regexResult !== null) {
                if (regexResult.length > 1) {

                    regexResult.map((match:string, index:number) => {
                        if (match.includes('Chrome')) {
                            parsedBrowser.browserName = regexResult[index].split('/')[0];
                            parsedBrowser.version = regexResult[index].split('/')[1];
                        }
                    });
                } else {
                    parsedBrowser.browserName = regexResult[0].split('/')[0];
                    parsedBrowser.version = regexResult[0].split('/')[1];
                }
            }

            return parsedBrowser;
        };

        const handleComparison = (warnBrowsers: [], userBrowser: IUserBrowser) => {
            let isWarningUser = false;
            if (!warnBrowsers || !isObjEmpty(userBrowser)) {
                return isWarningUser;
            }

            warnBrowsers?.forEach((warnBrowser: IWarnBrowser) => {
                if (warnBrowser.osName === userBrowser.os && warnBrowser.browserName === userBrowser.browserName &&
                    (isUserVersionWithinRange(warnBrowser.browserVersionMinimum, userBrowser.version!, warnBrowser.browserVersionSupported))
                ) {
                    isWarningUser = true;
                }
            });

            return isWarningUser;
        };

        const handleRedirect = (redirectBrowsers: [], warnBrowsers: []) => {
            let isRedirectingUser = false;
            const browserInfo = getBrowserInfo();

            if (!(window.location.host.indexOf('4502') > -1) && browserInfo?.name && browserInfo?.version) {
                
                redirectBrowsers?.forEach((redirectBrowsers: IRedirectBrowser) => {
                    if (redirectBrowsers.value === browserInfo.name) {
                        isRedirectingUser = true;
                    }
                });

                if (!isRedirectingUser) {
                    warnBrowsers?.forEach((warnBrowsers: IWarnBrowser) => {
                        const versions = parseVersions([warnBrowsers.browserVersionMinimum, browserInfo.version]);
                        if (warnBrowsers.browserName === browserInfo.name && versions[0] > versions[1]) {
                            isRedirectingUser = true;
                        }
                    });
                }
            } else if (!(window.location.host.indexOf('4502') > -1) && !browserInfo) {
                isRedirectingUser = true;
            }

            return isRedirectingUser;
        };

        function getBrowserInfo() {
            let tempVar;
            const browserInfo =
                window.navigator.userAgent.match(
                    /(samsungbrowser|opera|cake|aolshield|coc_coc_browser|ntentbrowser|msn|msnbot|enusmsn|heytapbrowser|mqqbrowser|cyberfox|ubrowser|safer|chrome|safari|firefox|msie|trident|crios|fxios(?=\/))\/?\s*(\d+)/i,
                ) || [];

            if (/trident/i.test(browserInfo[1])) {
                tempVar = /\brv[ :]+(\d+)/g.exec(window.navigator.userAgent) || [];
                return {
                    name: 'IE',
                    version: tempVar[1] || '',
                };
            }
            if (browserInfo[1] === 'Chrome') {
                tempVar = window.navigator.userAgent.match(/\bOPR\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'Opera',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bSafer\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'Safer',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bUBrowser\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'UBrowser',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bCake\)/);
                if (tempVar !== null) {
                    return {
                        name: 'Cake',
                        version: -1,
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bcoc_coc_browser\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'coc_coc_browser',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bNTENTBrowser\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'NTENTBrowser',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bHeyTapBrowser\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'HeyTapBrowser',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bAOLShield\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'AOLShield',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bMQQBrowser\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'MQQBrowser',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bEdge\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'Edge',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bDuckDuckGo\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'DuckDuckGo',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bUCBrowser\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'UCBrowser',
                        version: tempVar[1],
                    };
                }
            }
            if (browserInfo[1] === 'IE') {
                tempVar = window.navigator.userAgent.match(/\bMSN\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'MSN',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bmsnbot\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'msnbot',
                        version: tempVar[1],
                    };
                }
                tempVar = window.navigator.userAgent.match(/\bENUSMSN\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'ENUSMSN',
                        version: tempVar[1],
                    };
                }
            }
            if (browserInfo[1] === 'Firefox') {
                tempVar = window.navigator.userAgent.match(/\bCyberfox\/(\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'Cyberfox',
                        version: tempVar[1],
                    };
                }
            }
            /* Check to see if Chrome and Firefox on iOS as both browsers use Safari under the hood only on iOS */
            // Check for Chrome on iOS
            if (browserInfo[1] === 'CriOS') {
                tempVar = window.navigator.userAgent.match(/\bVersion\/(\d+)/);
                // Attempt to match underlying Safari version
                if (tempVar !== null) {
                    return {
                        name: 'Safari',
                        version: tempVar[1],
                    };
                    // If the user agent does not return underlying Safari Version, use Chrome revision
                } 

                return {
                    name: 'Chrome',
                    version: browserInfo[2],
                };
            }
            // Check for Firefox on iOS
            if (browserInfo[1] === 'FxiOS') {
                tempVar = window.navigator.userAgent.match(/\bVersion\/(\d+)/);
                return {
                    // Use Safari as name since Firefox iOS version does not match with other Firefox versions
                    name: 'Safari',
                    version: tempVar !== null ? tempVar[1] : browserInfo[2],
                };
            }
            //check for Safari browser specifically since safari version display in userAgent is different than other browsers
            if (browserInfo[1] === 'Safari') {
                tempVar = window.navigator.userAgent.match(/\bVersion\/(\d+\.?\d+)/);
                if (tempVar !== null) {
                    return {
                        name: 'Safari',
                        version: tempVar[1],
                    };
                }
            }

            return {
                name: browserInfo[1],
                version: browserInfo[2],
            };
            
        }

        const params = JSON.parse(PathUtils.getMetaPropertyValue('unsupportedBrowsers') as string);
        if (!params || ( params?.warnBrowsers < 1 && params?.redirectBrowsers < 1)) {
            return;
        }
        const userBrowser = navigator.userAgent;
        const isSupportedBrowsersPage = window.location.toString().search('/supported-browsers') !== -1;
        const isRedirectingUser = handleRedirect(params.redirectBrowsers, params.warnBrowsers);
        if (isRedirectingUser && !isSupportedBrowsersPage) {
            window.location.href = '/supported-browsers';
        }


        const isWarningUser = handleComparison(params.warnBrowsers, parseUserBrowser(userBrowser));
        if (isWarningUser && !SessionStorage.verify('wasWarnedOfUnsupportedBrowser')) {
            showPushdown('browserUpgrade');
            SessionStorage.set('wasWarnedOfUnsupportedBrowser', 'true');
        }
    }

    useEffect(() => {
        const isAuthor = (window.location.host.indexOf('4502') > -1) || (window.location.host.indexOf('3000') > -1);
        if (!isAuthor) {
            handleUnsupportedBrowsers();
        }
    }, []);


    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    );
};
